export const siteConfig = {
  name: '农民影视',
  tagline: '电影大全与电视剧全集 | 影视分类片库丰富免费高清在线观看',
  description:
    '农民影视打造影视大全，提供电影大全、电视剧全集、影视分类等所有影视资源，片库丰富，免费高清在线观看不缓冲，轻松检索您想看的每一部影视作品。',
  keywords: '农民影视,电影大全,电视剧全集,影视分类,所有影视资源,片库丰富,免费高清,在线观看,不缓冲,高清全集',
  url: 'https://www.nongminyingshi.com',
  logo: '农民影视',
  language: 'zh-CN',
  locale: 'zh_CN',
};